import React, { useContext, useEffect, useState } from "react";
import authorProfile from "../../Data/AuthorProfileData";
import { FaRegEdit } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import Globe from '../../utils/Icons/Globe.svg'
import Twitter from '../../utils/Icons/Twitter.svg'
import Linkedin from '../../utils/Icons/Linkedin.svg'
import Dribble from '../../utils/Icons/Dribbble.svg'
import Behance from '../../utils/Icons/behance.svg'
import Instagram from '../../utils/Icons/instagram.svg'
export const AuthorProfile = () => {
  const fetchFromLocalStorage = () => {
    const data = localStorage.getItem("profileData");
    return data ? JSON.parse(data) : null;
  };

  const [profileData, setProfileData] = useState(fetchFromLocalStorage());
  

  useEffect(() => {
    const data = fetchFromLocalStorage();
    setProfileData(data);
  }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <div>
        {authorProfile.map((author) => (
          <div>
            <div className="w-fit mx-auto">
              <img className="w-16 h-16 rounded-full object-cover" src={'https://images.pexels.com/photos/22027141/pexels-photo-22027141/free-photo-of-farmer-in-hat-sitting-on-field.jpeg?auto=compress&cs=tinysrgb&w=400&lazy=load'} alt="" />
            </div>
            <div className="text-center">
              <h1 className="pt-2 text-[32px]">{author.author}</h1>
              <div className="flex items-center space-x-2 justify-center">
                <div className="bg-[#30A242] w-2 h-2 rounded-full"/>
                <p className="text-lg">Available for Work</p>
              </div>
              <div className="flex items-center justify-center space-x-3 pt-6 pb-4">

                <div className="bg-[#E7E7E7] w-fit p-[10px] rounded-lg">
                  <img className="w-5 h-5" src={Globe} alt="" />
                </div>
                <div className="bg-[#E7E7E7] w-fit p-[10px] rounded-lg">
                  <img className="w-5 h-5" src={Twitter} alt="" />
                </div>
                <div className="bg-[#E7E7E7] w-fit p-[10px] rounded-lg">
                  <img className="w-5 h-5" src={Linkedin} alt="" />
                </div>
                <div className="bg-[#E7E7E7] w-fit p-[10px] rounded-lg">
                  <img className="w-5 h-5" src={Dribble} alt="" />
                </div>
                <div className="bg-[#E7E7E7] w-fit p-[10px] rounded-lg">
                  <img className="w-5 h-5" src={Behance} alt="" />
                </div>
                <div className="bg-[#E7E7E7] w-fit p-[10px] rounded-lg">
                  <img className="w-5 h-5" src={Instagram} alt="" />
                </div>
              </div>
              <p className="text-lg py-2 lg:w-[60%] mx-auto">{author.about}</p>
            </div>
            <div className="mt-2 flex w-fit mx-auto  items-center space-x-2 bg-[#1c1c1c] text-xl text-white dark:bg-white dark:text-black px-4 py-3 rounded-xl">
              <FiEdit/>
              <p >
                Edit Profile
              </p>
            </div>
            <div className="py-6 grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
              {author.work.map((work) => (
                <div className="h-80 w-full xl:w-[305px]  xl:h-[220px] my-4">
                  <img
                    className="object-cover rounded-2xl w-full h-full"
                    src="https://images.pexels.com/photos/13518944/pexels-photo-13518944.jpeg?auto=compress&cs=tinysrgb&w=800&lazy=load"
                    alt=""
                  />
                  <div className="flex items-center justify-between">
                    <p className="text-xl">{work.title}</p>
                    <p className="text-xl shrink-0 my-2 bg-black text-white dark:bg-white dark:text-black px-2 rounded-lg">
                      ${work.price}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
